var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "36673516-1080-4eff-8ecf-5d76ec46c08f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "080a9f3f-7506-49ab-bee4-05ce9af33b5c"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.77 0 0 8.55 234.25 579.93)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 17.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-50, -67.69)",
    d: "M 80 71.2 L 80 74 C 80 77.3 77.3 80 74 80 L 26 80 C 22.7 80 20 77.3 20 74 L 20 71.2 C 20 63.900000000000006 28.5 59.5 36.5 56 C 36.8 55.9 37 55.8 37.3 55.6 C 37.9 55.300000000000004 38.599999999999994 55.300000000000004 39.199999999999996 55.7 C 42.4 57.8 46.1 59 50 59 C 53.9 59 57.6 57.8 60.8 55.8 C 61.4 55.4 62.099999999999994 55.4 62.699999999999996 55.699999999999996 C 62.99999999999999 55.8 63.199999999999996 55.9 63.49999999999999 56.099999999999994 C 71.5 59.5 80 63.9 80 71.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -13.5)",
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    rx: 14.9,
    ry: 16.5
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.47 0 0 1.52 762.5 578.04)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-199.54, -160)",
    d: "M -4.26325641e-14 213.333333 L 106.666667 213.333333 L 106.666667 256 L -4.26325641e-14 256 L -4.26325641e-14 213.333333 Z M -4.26325641e-14 149.333333 L 149.333333 149.333333 L 149.333333 106.666667 L -4.26325641e-14 106.666667 L -4.26325641e-14 149.333333 Z M -4.26325641e-14 42.6666667 L 192 42.6666667 L 192 -2.84217094e-14 L -4.26325641e-14 -2.84217094e-14 L -4.26325641e-14 42.6666667 Z M 368.916693 189.31904 L 320 238.235733 L 320 -2.84217094e-14 L 277.333333 -2.84217094e-14 L 277.333333 238.235733 L 228.41664 189.31904 L 198.250027 219.485653 L 298.666667 320 L 399.083307 219.485653 L 368.916693 189.31904 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDied);
export default __webpack_public_path__ + "static/media/died.0f467a0950b824ec3b9c448c5a019315.svg";
export { ForwardRef as ReactComponent };